export enum EName {
    CMP     = 'cmp',
    CMP_BOT = 'cmp_bot',
}

export enum EAction {
    CONFIGURAR  = 'configurar',
    GDPR        = 'gdpr',
    INSIST      = 'rechazar',
}

export enum ELabel {
    APARECE                         = 'aparece',
    SOCIOS                          = 'socios',
    CONFIGURACION                   = 'configuracion',
    YA_ACEPTADO                     = 'ya_aceptado',
    ACEPTAR                         = 'aceptar',
    RECHAZAR                        = 'rechazar',
    CERRAR                          = 'cerrar',
    RECHAZAR_TODO                   = 'rechazar_todo',
    ACEPTAR_TODO                    = 'aceptar_todo',
    ACEPTAR_TODO_GUARDAR            = 'aceptar_todo_guardar',
    GUARDAR_CERRAR_DESHABILITADO    = 'guardar_cerrar_deshabilitado',
    GUARDAR_CERRAR_HABILITADO       = 'guardar_cerrar_habilitado',
    INICIA_SESION                   = 'inicia_sesion',
    REGISTRARSE                     = 'registrarse',
    ACEPTO_Y_CAMBIO                 = 'acepto_y_cambio',
    ACEPTAR_GLOBAL                  = 'aceptar_global',
    RECHAZAR_GLOBAL                 = 'rechazar_global',
    APARECE_GLOBAL                  = 'aparece_global',
}
